import { routes } from '@shared/config';

const displaySteps = ['Setup MFA', 'Confirm MFA'];
const steps = [routes.auth.mfa.setup(), routes.auth.mfa.confirm()];

export { steps, displaySteps };
